
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitovadodaracab() {



    const cardData =
    {
        keyword: ' Mumbai to Vadodara Cab  ',
        heading: 'Deva Cabs: Mumbai to Vadodara Cab  ',
        headingDescription: 'Deva Cabs offers efficient and comfortable cab services from Mumbai to Vadodara, perfect for business travel, family visits, and long-distance journeys. Covering a distance of approximately 420 km, our well-maintained fleet—Sedans, SUVs, and Innova Crysta—ensures a smooth, comfortable, and enjoyable ride. Travel with confidence thanks to our experienced chauffeurs, fixed-fare packages, and convenient door-to-door pickup and drop-off. With 24/7 availability, transparent pricing, and exceptional customer support, Deva Cabs guarantees a stress-free and reliable Mumbai to Vadodara cab experience.',

        top: 'Top Places to Visit in Vadodara with Deva Cabs',

"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "location": "Vadodara, Gujarat",
    "description": "Built in 1890 by Maharaja Sayajirao Gaekwad III, this Indo‑Saracenic marvel is four times larger than Buckingham Palace. With opulent interiors, vibrant stained‑glass windows, an original elevator from the late 19th century, and its own golf course, it still functions as the royal Gaekwad residence while housing a museum full of rare artifacts and European artwork."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "location": "Vadodara, Gujarat",
    "description": "Spread over 113 acres, this expansive public garden features a zoo, planetarium, toy train, boating lake, musical fountains, flower clock, and Baroda Museum & Picture Gallery. It’s a favorite family spot for leisurely walks, educational outings, and cultural events."
  },
  {
    "title": "Baroda Museum & Picture Gallery",
    "location": "Sayaji Baug, Vadodara, Gujarat",
    "description": "Located within Sayaji Baug, this museum boasts a stunning collection—from Egyptian mummies and a blue whale skeleton to ancient Indian Akota bronzes, Mughal miniatures, and Western masterpieces by Turner and Constable—housed in an elegant Indo‑Maratha architectural marvel."
  },
  {
    "title": "Maharaja Fatehsingh Museum",
    "location": "Within Laxmi Vilas Palace grounds, Vadodara, Gujarat",
    "description": "Housed in the former Motibaug School, this museum showcases royal treasures including European Renaissance and Rococo paintings, marble busts, and over two dozen works by Raja Ravi Varma. Its regal setting and curated collection reflect the Gaekwad family's refined taste."
  },
  {
    "title": "Champaner–Pavagadh Archaeological Park",
    "location": "Champaner, near Vadodara, Gujarat",
    "description": "A UNESCO World Heritage Site featuring a medieval fortified city, palaces, mosques, Hindu and Jain temples, elaborate step‑wells, and hilltop shrines. It offers a captivating blend of Sultanate-era architecture and adventurous trekking up Pavagadh Hill to the Kalika Mata temple."
  },
  {
    "title": "Sursagar Lake",
    "location": "Vadodara, Gujarat",
    "description": "This scenic urban lake features a 111‑ft high gold‑plated statue of Shiva at its center, stone embankments for leisurely evening strolls, and newly restored boating facilities. It blends spiritual ambiance with city charm."
  },
  {
    "title": "Tapovan Temple",
    "location": "Vadodara, Gujarat",
    "description": "Nestled within the gardens of the local oil company (IOCL), this tranquil temple is dedicated to Lord Karthik and Balaji. Surrounded by lawns and meditation spaces, it provides a peaceful sanctuary away from the hustle of the city."
  },
  {
    "title": "Makarpura Palace",
    "location": "Vadodara, Gujarat",
    "description": "Constructed in 1870 as a summer retreat for the Gaekwad royal family, this Italian Renaissance-style palace features elegant arched corridors, grand halls, and manicured gardens. Later converted into an Air Force training facility, it blends princely architecture with historical significance."
  },
  {
    "title": "Kirti Mandir",
    "location": "Vadodara, Gujarat",
    "description": "Built in 1936 as a memorial to Gaekwad royalty, this Indo‑Saracenic temple‑memorial complex features a towering bronze-topped shikhara, beautifully painted frescoes by Nandalal Bose, majestic shrines for Rama and Krishna, and landscaped surroundings that elevate both spiritual and aesthetic experiences."
  },
  {
    "title": "Vishwamitri River & Crocodile Habitat",
    "location": "Vadodara, Gujarat",
    "description": "Flowing through the city, this river is home to a rare population of mugger crocodiles. The riverside area offers a unique opportunity for wildlife observation—visitors can spot crocodiles basking on the banks during winter, making it one of the few urban wildlife experiences in India."
  }
],



 "services": [
    {
      "name": "Mumbai to Vadodara Cab",
      "description": "Travel conveniently from Mumbai to Vadodara with our reliable outstation cab service. Perfect for business trips, family travel, or long-distance journeys, our cabs offer AC comfort, spacious interiors, and professional drivers who ensure a safe and relaxing ride. Choose from multiple vehicle types including sedans, SUVs, and premium options for your travel needs. We provide door-to-door pickup, flexible scheduling, and fully sanitized vehicles for your peace of mind."
    },
    {
      "name": "Book taxi Mumbai to Baroda",
      "description": "Book your taxi from Mumbai to Baroda (Vadodara) with just a click. Our booking system is quick, secure, and user-friendly, offering real-time availability and instant confirmation. Whether for a same-day trip or a planned tour, we ensure timely service, verified drivers, and transparent pricing without hidden charges."
    },
    {
      "name": "Mumbai to Vadodara one-way cab",
      "description": "Looking for a one-way cab from Mumbai to Vadodara? We offer cost-effective and comfortable rides ideal for solo travelers, families, or small groups. Our one-way service is designed to provide flexibility, value, and ease of travel with no extra charges for return journeys. Enjoy a smooth highway ride with AC comfort and courteous drivers."
    },
    {
      "name": "AC cab hire Mumbai to Vadodara",
      "description": "Hire an air-conditioned cab from Mumbai to Vadodara for a pleasant long-distance journey. Our cabs are equipped with powerful cooling, plush seating, and ample legroom—ensuring a relaxing travel experience even in hot weather. Great for both corporate and personal trips, our AC cabs are available in all seating categories."
    },
    {
      "name": "SUV cab from Mumbai to Baroda",
      "description": "Planning to travel with more people or extra luggage? Our SUV cabs from Mumbai to Baroda offer comfort, space, and superior ride quality. Ideal for families, groups, or travelers with equipment, our SUVs come with reclining seats, AC, and trained drivers familiar with the Mumbai–Vadodara route."
    },
    {
      "name": "Chauffeur cab Mumbai to Baroda",
      "description": "Enjoy a stress-free trip to Baroda with our chauffeur-driven cab service from Mumbai. Our professional drivers prioritize safety and punctuality while offering courteous and helpful service throughout your journey. Whether it's a business trip or personal travel, sit back and enjoy the ride while we handle the rest."
    },
    {
      "name": "Affordable Baroda cab from Mumbai",
      "description": "Get the best value on your trip from Mumbai to Baroda with our budget-friendly cab service. We offer fair and transparent pricing, quality vehicles, and excellent service. Perfect for solo passengers or families looking for economical outstation travel without compromising comfort or safety."
    },
    {
      "name": "Round trip Vadodara cab Mumbai",
      "description": "Need a return cab too? Book our round trip service from Mumbai to Vadodara and enjoy complete travel convenience. We offer flexible return scheduling, no hidden charges, and discounted round trip rates. Ideal for business travelers and families looking to travel to and from Baroda in one seamless plan."
    },
    {
      "name": "Online cab booking Mumbai to Vadodara",
      "description": "Book your cab online from Mumbai to Vadodara in minutes. Our digital booking system is quick, secure, and offers multiple options including one-way, round trip, and multi-city routes. Choose your preferred vehicle, confirm instantly, and get set for a comfortable journey backed by professional support."
    }
  ],
  "tableData": [
    ["Mumbai to Vadodara Cab", "-Book taxi Mumbai to Baroda"],
    ["Mumbai to Vadodara one-way cab", "-AC cab hire Mumbai to Vadodara"],
    ["SUV cab from Mumbai to Baroda", "-Chauffeur cab Mumbai to Baroda"],
    ["Affordable Baroda cab from Mumbai", "-Round trip Vadodara cab Mumbai"],
    ["Online cab booking Mumbai to Vadodara", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Vadodara Cab Service",
    "WhyChoosedescription": "Experience a comfortable and dependable journey from Mumbai to Vadodara with our professional cab service. Ideal for business travelers, families, and tourists, we ensure timely pickups and smooth travel across the approximately 420 km route. Trust us for a hassle-free trip with experienced drivers and well-maintained vehicles."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Our fleet includes air-conditioned sedans, SUVs, and larger vehicles, all designed to provide ample legroom and luggage space. Enjoy ergonomic seating and modern amenities that make your long journey to Vadodara relaxing and enjoyable."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Vadodara Route",
    "WhyChoosedescription": "Our professional drivers are well-versed in the highways and routes connecting Mumbai and Vadodara. They prioritize safety, punctuality, and passenger comfort, ensuring a smooth and timely journey while expertly navigating traffic and road conditions."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear, upfront pricing inclusive of tolls, fuel, and driver allowances, with no hidden fees. Our competitive rates allow you to plan your budget confidently, making our Mumbai to Vadodara cab service affordable and reliable."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cabs are available round the clock to suit your preferred travel times. Whether you want to start early morning or late at night, we provide the flexibility to fit your schedule and ensure seamless travel."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Vadodara cab is quick and convenient through our website or customer support. Receive instant confirmation along with fare and driver details, helping you plan your trip with confidence."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly maintained and sanitized to ensure safety and hygiene. Equipped with seat belts, GPS tracking, and emergency kits, our cabs prioritize your security and comfort throughout the journey."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages",
    "WhyChoosedescription": "We offer flexible travel options including one-way, round trips, and multi-day journeys with stops at points of interest. Our services can be tailored to meet your specific travel needs for the Mumbai to Vadodara route."
  }
]









    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Vadodara with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and comfortable cab services from Mumbai to Vadodara for both personal and business travel."
  },
  {
    question: "How long does it take to travel from Mumbai to Vadodara by cab?",
    answer: "The journey typically takes around 6 to 8 hours depending on traffic and route conditions."
  },
  {
    question: "What vehicle options are available for the Mumbai to Vadodara route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit different travel needs."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Vadodara?",
    answer: "Yes, both one-way and round-trip bookings are available for Mumbai to Vadodara cab services."
  },
  {
    question: "Are tolls, parking charges, and driver allowance included in the fare?",
    answer: "Tolls, parking fees, and driver allowance are generally extra and will be clearly communicated during booking."
  },
  {
    question: "Is the Mumbai to Vadodara cab service available 24/7?",
    answer: "Yes, Deva Cabs operates 24/7 to provide flexible travel options for your convenience."
  },
  {
    question: "Is it safe to travel long distances like Mumbai to Vadodara with Deva Cabs?",
    answer: "Absolutely. Our drivers are experienced, professional, and background-verified to ensure a safe and pleasant journey."
  },
  {
    question: "Can I schedule stops or breaks along the way to Vadodara?",
    answer: "Yes, you can plan halts or sightseeing en route. Just mention your preferences at the time of booking."
  },
  {
    question: "Is this service suitable for families, corporate groups, or senior citizens?",
    answer: "Yes, our services are ideal for all types of travelers, including families, groups, and elderly passengers."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Vadodara cab services?",
    answer: "Deva Cabs offers timely service, clean and well-maintained vehicles, transparent pricing, and courteous drivers for a smooth journey."
  }
];

const testimonialData = [
  {
    id: 69,
    name: 'Mr. Anil Shah',
    role: 'Business Traveler',
    review: 'My trip from Mumbai to Vadodara with Deva Cabs was smooth and punctual. Great service and clean car.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 70,
    name: 'Mrs. Meena Trivedi',
    role: 'Family Traveler',
    review: 'Deva Cabs provided a comfortable ride from Mumbai to Vadodara for our family. The driver was friendly and helpful.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Vadodara Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-vadodara-cab.jpg", // Update with actual image URL
  "description": "Book Mumbai to Vadodara cab online with Deva Cabs. One-way and round-trip taxi services with AC, SUV, chauffeur-driven and affordable options available for Baroda travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "470"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-vadodara-cab" // Update with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Vadodara Cab | Book Taxi Online | Deva Cabs</title>
  <meta
    name="description"
    content="Book your Mumbai to Vadodara cab with Deva Cabs. Affordable AC and SUV taxi hire, chauffeur-driven options, one-way and round-trip service available. Easy online booking."
  />
  <meta
    name="keywords"
    content="Mumbai to Vadodara Cab, Book taxi Mumbai to Baroda, Mumbai to Vadodara one-way cab, AC cab hire Mumbai to Vadodara, SUV cab from Mumbai to Baroda, Chauffeur cab Mumbai to Baroda, Affordable Baroda cab from Mumbai, Round trip Vadodara cab Mumbai, Online cab booking Mumbai to Vadodara"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitovadodaracab;